import {COPILOT_PATH} from '@github-ui/copilot-chat/utils/copilot-chat-helpers'

export interface BuildCopilotUpdateIssueUrlParams {
  ownerLogin: string
  repoName: string
  issueNumber: string
  commentBody: string
}

/**
 * Builds the Copilot URL for updating an issue based on comment feedback.
 * This is extracted to a shared function so it can be used in both the hook and tests.
 */
export function buildCopilotUpdateIssueUrl({
  ownerLogin,
  repoName,
  issueNumber,
  commentBody,
}: BuildCopilotUpdateIssueUrlParams): string {
  const prompt = `Using the following feedback, update the issue body in @${ownerLogin}/${repoName}/issues/${issueNumber} and also make sure to include a diff of your changes in your response.

<feedback>
${commentBody}
</feedback>`
  const params = new URLSearchParams({prompt})
  return `${COPILOT_PATH}?${params.toString()}`
}
